import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { LayoutDashboard, Building2, CreditCard, LogOut, ShieldCheck, Menu, X, BarChart3, CalendarCheck } from "lucide-react";
import { cn } from "@/lib/utils";

const NAV = [
  { to: "/admin", end: true, icon: LayoutDashboard, label: "Genel Bakış", testid: "admin-nav-dashboard" },
  { to: "/admin/isletmeler", icon: Building2, label: "İşletmeler", testid: "admin-nav-businesses" },
  { to: "/admin/rezervasyonlar", icon: CalendarCheck, label: "Rezervasyonlar", testid: "admin-nav-reservations" },
  { to: "/admin/planlar", icon: CreditCard, label: "Planlar", testid: "admin-nav-plans" },
  { to: "/admin/rapor", icon: BarChart3, label: "Gelir Raporu", testid: "admin-nav-reports" },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = React.useState(false);
  const doLogout = async () => { await logout(); nav("/giris"); };

  const Sidebar = () => (
    <>
      <div className="flex items-center gap-2 px-5 h-16 border-b border-white/10">
        <div className="w-8 h-8 rounded-lg bg-primary flex items-center justify-center">
          <ShieldCheck className="w-5 h-5 text-primary-foreground" />
        </div>
        <div className="leading-tight">
          <span className="font-display font-bold text-lg text-white">365Rez</span>
          <p className="text-[10px] uppercase tracking-wider text-white/50">Yönetim Paneli</p>
        </div>
      </div>
      <nav className="flex-1 p-3 space-y-1">
        {NAV.map((n) => (
          <NavLink key={n.to} to={n.to} end={n.end} onClick={() => setOpen(false)} data-testid={n.testid}
            className={({ isActive }) => cn(
              "flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors duration-200",
              isActive ? "bg-primary text-primary-foreground" : "text-white/70 hover:bg-white/10 hover:text-white"
            )}>
            <n.icon className="w-4.5 h-4.5" style={{ width: 18, height: 18 }} /> {n.label}
          </NavLink>
        ))}
      </nav>
      <div className="p-3 border-t border-white/10">
        <div className="px-3 py-2 mb-2">
          <p className="text-sm font-semibold text-white truncate">{user?.name}</p>
          <p className="text-xs text-white/50 truncate">{user?.email}</p>
        </div>
        <Button variant="ghost" className="w-full justify-start gap-3 text-white/70 hover:text-white hover:bg-white/10" onClick={doLogout} data-testid="admin-logout-btn">
          <LogOut className="w-4 h-4" /> Çıkış Yap
        </Button>
      </div>
    </>
  );

  return (
    <div className="min-h-screen bg-background flex" translate="no">
      <aside className="hidden lg:flex w-64 flex-col fixed inset-y-0 bg-slate-900">
        <Sidebar />
      </aside>
      {open && (
        <div className="lg:hidden fixed inset-0 z-50 flex">
          <div className="absolute inset-0 bg-black/50" onClick={() => setOpen(false)} />
          <aside className="relative w-64 flex flex-col bg-slate-900">
            <button className="absolute top-4 right-4 text-white" onClick={() => setOpen(false)}><X className="w-5 h-5" /></button>
            <Sidebar />
          </aside>
        </div>
      )}
      <div className="flex-1 lg:ml-64 min-w-0">
        <header className="lg:hidden sticky top-0 z-40 h-14 flex items-center gap-3 px-4 border-b border-border bg-slate-900 text-white">
          <button onClick={() => setOpen(true)} data-testid="admin-open-menu"><Menu className="w-6 h-6" /></button>
          <span className="font-display font-bold">365Rez Yönetim</span>
        </header>
        <main className="p-5 sm:p-8 max-w-6xl" translate="no"><Outlet /></main>
      </div>
    </div>
  );
}
